
export function setCurrentView (v) {
    this.currentView = v;
}

export function setNextView (v) {
    this.nextView = v;
}

export function setBackView (v) {
    this.backView = v;
}

export function setRenderer (funcName) {
    const func = this.views[funcName];
    this.setViewFunc(func);
}

export function setDirection (v) {
    this.direction = v; // possible values: 'back' or 'next'
}

export function setDuration (v) {
    this.duration = v;
}

export function setTransitionsProps (p) {
    const {
        animationIn,
        animationOut,
        direction,
    } = p;
    this.animationIn = animationIn;
    this.animationOut = animationOut;
    this.direction = direction;
}

export function setTransitionsWithTarget (p) {
    const {
        animationIn,
        animationOut,
        incomingView,
        outgoingView,
        direction,
    } = p;
    this.animationIn = animationIn;
    this.animationOut = animationOut;
    this.incomingView = incomingView;
    this.outgoingView = outgoingView;
    this.direction = direction;
}

export function setIncomingView (v) {
    this.incomingView = v;
}

export function setOutgoingView (v) {
    this.outgoingView = v;
}
